const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Normal Distribution Chart component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('horizontalBarChart', [function () {
  return {
    restrict: 'E',
    scope: {
      data: '=',
      labels: '='
    },
    template: require('../../../templates/directives/assessments/horizontal-bar-chart.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      var chart = {
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scaleShowVerticalLines: false,
          scaleLineColor: '#f7f7f7',
          scaleFontSize: 14,
          scaleLabel: " <%=value%>",
          scaleFontFamily: '"Gotham SSm A","Gotham SSm B",Helvetica,Arial,sans-serif',
          pointDotRadius : 0,
          pointDotStrokeWidth : 0,
          bezierCurve : false,
          showTooltips: false,
          scaleShowLabels: true,
          scales: {
            xAxes: [{
              gridLines: {
                display: false
              }
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
                callback: function(value) {if (value % 1 === 0) {return value;}}
              }
            }]
          }
        },
        colorConfig: {
          baseColors: [],
          currColors: [],
          dimmedColor: {},
          defaultColors: [0,1,2,3]
        },
        getColor : function(color) {
          return {
            backgroundColor: color[0],
            borderColor: 'transparent',
            pointBackgroundColor: color[1],
            pointBorderColor: 'white',
            pointHoverBackgroundColor: color,
            pointHoverBorderColor: 'white'
          };
        }
      };

      chart.colorConfig.baseColors = [
        ['rgba(33,190,241,.35)','#21bef1'], 
        ['rgba(54,194,110,.6)','#36c26e'], 
        ['rgba(232,98,87,.5)','#e86257'], 
        ['rgba(253,129,38,.65)','#fd8126'], 
        ['rgba(147,149,151,.5)','#c9cacb']
      ];
      chart.colorConfig.defaultColors = chart.colorConfig.defaultColors.map(function(idx) {
        return chart.getColor(chart.colorConfig.baseColors[idx]);
      });
      chart.colorConfig.dimmedColor = chart.getColor(chart.colorConfig.baseColors[4]);
      chart.colorConfig.currColors = chart.colorConfig.defaultColors;

      self.initialize = function() {
        chart.colours = chart.colorConfig.defaultColors;
        chart.labels = $scope.labels;
        chart.data = $scope.data;

        self.chart = chart;
      };

      if ($scope.data) {
        self.initialize();
      }

      $scope.$watch('data', function(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          self.initialize();
        }
      }, true);

    }],
    controllerAs: 'hbar'
  };
}]);
